import {Splide} from '@splidejs/splide';
import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger';

// product slider
let disciplineSlider = document.getElementsByClassName('discipline-slider');

document.addEventListener('DOMContentLoaded', function () {
    for (let i = 0; i < disciplineSlider.length; i++) {
        let splide = new Splide(disciplineSlider[i], {
            type: 'slide',
            rewind: true,
            pagination: true,
            arrows: true,
            width: '100%',
            perMove: 1,
            gap: 24,
            breakpoints: {
                1023: {
                    perPage: 2,
                },
                640: {
                    perPage: 1,
                },
            }
        });

        let track = splide.root.querySelector('.splide__track');
        let amount = track.getAttribute('data-number');

        //Set overflow when slider is active
        splide.on('mounted', function () {
            let total = splide.length;
            let arrows = splide.root.querySelector('.splide__arrows');
            track.classList.add('hasOverflow');

            if (total < 4 && amount == 3) {
                arrows.classList.add('hide-for-xlarge');
            }

            if (total < 5 && amount == 4) {
                arrows.classList.add('hide-for-xlarge');
            }
        });

        splide.mount();
    }
});

document.addEventListener('DOMContentLoaded', function () {
    var self = this;
    var jsDisciplines = Array.prototype.slice.call(document.querySelectorAll('.block_disciplines:not(.has-slider)'));

    jsDisciplines.forEach(function (self) {
        gsap.registerPlugin(ScrollTrigger);

        var tl = gsap.timeline({

            scrollTrigger: {
                trigger: self,
                start: 'top +=75%',
                end: 'bottom center',
                pin: false,
                scrub: true
            }
        });
        self.querySelectorAll('.item-inner img').forEach(function (el) {
            tl.to(el, {y: 0, duration: 2}, '>-=2');
        });
    });
});
